import { LanguageResource } from '../type';

export const fr: LanguageResource = {
  common: {
    hello: 'Bonjour',
    hosts: 'Hôtes',
  },
  signin: {
    signin: 'Se connecter',
    forgotpassword: 'Mot de passe oublié?',
    rememberme: 'Se souvenir de moi',
    logout: 'Se déconnecter',
    or: 'ou',
    password: 'Mot de passe',
    signup: "S'inscrire",
    sso: 'Se connecter avec SSO',
    terms1: 'En vous connectant, vous acceptez nos',
    terms2: "Conditions d'utilisation",
    terms3: 'et',
    terms4: 'Politique de confidentialité',
    username: "Nom d'utilisateur",
  },
} as any;
